<template>
  <div class="sales-page">
    <PageHeader
      :title="title"
      :subtitle="subtitle"
      :actions="actions"
      @action="$emit('action', $event)"
    />

    <div class="sales-content">
      <slot name="content">
        <slot name="metrics"></slot>
        <slot name="toolbar"></slot>
        <slot name="tabs"></slot>
        <slot name="table"></slot>
      </slot>
    </div>

    <slot name="modal"></slot>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue';

export default {
  name: 'SalesPageShell',
  components: {
    PageHeader,
  },
  props: {
    title: {
      type: String,
      default: 'Negocios',
    },
    subtitle: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['action'],
};
</script>
